import { Modal } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";

// Loading state used when a Cloud backup is being restored.
const RestoringBackupModal = () => {
  return (
    <Modal isOpen={true} className="modal-dialog-centered">
      <div className="border border-superlight shadow-sm rounded d-flex flex-column align-items-center p-5">
        <h1 className="mb-4">Restoring Cloud Backup...</h1>
        <AppSpinner
          style={{ height: "3.5rem", width: "3.5rem", fontSize: 25 }}
          className="mt-4 mb-5"
          size="xl"
        />
        <div style={{ fontWeight: 500 }} className="text-center">
          We're restoring your GrowthCloud instance. This will only take a
          minute or two.
        </div>
      </div>
    </Modal>
  );
};

export default RestoringBackupModal;
